import React from "react";
import { selectUser } from "../../../../../redux/user/user-selector";
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';

export default function ChatMessageUser({ message }) {
  const user = useSelector(selectUser);

  return (
    <div className="d-flex align-items-start chat-conversation-row bg-light">
      <div className="chat-conversation-user">
        {user?.profile?.userNameFull
          .split(" ")
          .map((str) => str[0])
          .join("")
          .toUpperCase()}
      </div>
      <div className="chat-conversation-row-text text-justify">{message}</div>
    </div>
  );
}

ChatMessageUser.propTypes = {
  message: PropTypes.string.isRequired,
};